import { SearchForm } from '../types';
import usePrevious from './usePrevious';

const useIsChanged = ({
  departureId,
  destinationId,
}: {
  departureId?: SearchForm['departureOption']['value'];
  destinationId?: SearchForm['destinationOption']['value'];
}) => {
  const prevDepartureId = usePrevious(departureId);
  const prevDestinationId = usePrevious(destinationId);

  const isDepartureIdChanged = prevDepartureId !== departureId;
  const isDestinationIdChanged = prevDestinationId !== destinationId;

  return {
    isDepartureIdChanged,
    isDestinationIdChanged,
  };
};

export default useIsChanged;
